module.exports = __webpack_public_path__ + "static/media/my_vitamin.399a28a8.png";